import { Button } from "@/components/ui/button";
import { HeroConfig } from "@/config/heroConfig";

interface HeroButtonsProps {
  config: HeroConfig['buttons'];
}

export const HeroButtons = ({ config }: HeroButtonsProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
      <Button variant="hero" size="xl" className="group min-h-[48px] text-base px-6" asChild>
        <a href={config.primary.href} className="flex items-center justify-center">
          <span className="xs:hidden">{config.primary.text.mobile}</span>
          <span className="hidden xs:inline">{config.primary.text.desktop}</span>
          <div className="ml-2 group-hover:translate-x-1 transition-transform">{config.primary.icon}</div>
        </a>
      </Button>
      <Button variant="playful" size="xl" className="min-h-[48px] text-base px-6" asChild>
        <a href={config.secondary.href} className="flex items-center justify-center">
          {config.secondary.text}
        </a>
      </Button>
    </div>
  );
};